import classNames from 'classnames';

import { useWindowDimensions } from 'my-core/hooks';

import { BANNER_TRANSITION_DURATION } from 'my-components/Root/SiteWideBanner';

import Drawer, { drawerClasses } from '@mui/material/Drawer';
import useMediaQuery from '@mui/material/useMediaQuery';

export const DRAWER_MODE_BREAKPOINT = 'md';
const PERSISTENT_DRAWER_WIDTH = 320;
export const DRAWER_TRANSITION_DURATION = 150;
const rootCss = ({ breakpoints, constants: { APPBAR_OFFSET }, transitions }) => ({
  height: ['100vh', '100dvh'],
  display: 'flex',
  flexDirection: 'column',
  paddingTop: APPBAR_OFFSET,
  containerType: 'inline-size',
  transition: [
    transitions.create('margin-left', { duration: DRAWER_TRANSITION_DURATION }),
    transitions.create('padding-top', { duration: BANNER_TRANSITION_DURATION }),
  ].join(', '),
  '&.root_noTransition': { transition: 'none' },

  [breakpoints.up(DRAWER_MODE_BREAKPOINT)]: {
    '&.root_drawerOpen': { marginLeft: PERSISTENT_DRAWER_WIDTH },
  },
});
const drawerCss = ({ breakpoints, constants: { APPBAR_OFFSET }, transitions }) => ({
  [`& .${drawerClasses.paper}`]: {
    width: '100%',
    maxWidth: 400,
    zIndex: 'auto', // default drawer shows up over appbar (and appbar library menu)

    [breakpoints.up(DRAWER_MODE_BREAKPOINT)]: {
      top: APPBAR_OFFSET,
      height: `calc(100% - ${APPBAR_OFFSET}px)`,
      width: PERSISTENT_DRAWER_WIDTH,
      transition: transitions.create('top', { duration: BANNER_TRANSITION_DURATION }),
    },
  },
});

export default function OnlineCourseLayout({ children, disableAutoCapture, drawer, drawerOpen, onClose }) {
  const isSmall = useMediaQuery(({ breakpoints }) => breakpoints.down(DRAWER_MODE_BREAKPOINT));

  const { height } = useWindowDimensions();

  return (
    <>
      {drawer && (
        <Drawer
          css={drawerCss}
          data-ph-no-autocapture={disableAutoCapture || undefined}
          ModalProps={{ keepMounted: true }} // Make sure to keep sidebar mounted so tour steps always defined & state maintained (search / bookmarks mode)
          onClose={onClose}
          open={!!drawerOpen}
          transitionDuration={DRAWER_TRANSITION_DURATION}
          variant={isSmall ? 'temporary' : 'persistent'}
        >
          {drawer}
        </Drawer>
      )}
      <div
        className={classNames({ root_drawerOpen: !!drawer && drawerOpen, root_noTransition: !drawer })}
        css={rootCss}
        data-ph-no-autocapture={disableAutoCapture || undefined}
        style={{ height }}
      >
        {children}
      </div>
    </>
  );
}
